export default __webpack_public_path__ + "static/media/background-cadastro-beneficiario.67a89e1d.jpg";